export default __webpack_public_path__ + "static/media/svg-4.cbf1ce0f.svg";